import { FinanceMainSection } from './FinanceMainSection';

export default FinanceMainSection;
